"use client";

import Link, { LinkProps } from "next/link";
import React from "react";
import { useRouter } from "next/navigation";
import { useUnsavedChanges } from "./unsaved-changes-guard";

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & LinkProps;

export function GuardedLink({ href, replace, prefetch, target, onClick, ...rest }: Props) {
  const router = useRouter();
  const { dirty, confirmNavigate } = useUnsavedChanges();

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    onClick?.(e);

    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey ||
      (target && target !== "_self")
    ) {
      return;
    }

    if (!dirty) return;

    e.preventDefault();

    const ok = await confirmNavigate();
    if (!ok) return;

    if (replace) router.replace(href as any);
    else router.push(href as any);
  };

  return (
    <Link
      href={href}
      replace={replace}
      prefetch={prefetch}
      target={target}
      onClick={handleClick}
      {...rest}
    />
  );
}
